export enum mensajeModalListadoTrabajadores {
    procesando = 'Esto puede tardar varios minutos, no cierre esta ventana.',
    confirmacion = 'Se ha generado y descargado con éxito el archivo con el listado de trabajadores afiliados a su empresa.',
    confirmacionYEnvio = 'Esto puede tardar varios minutos. Cuando esté listo el archivo recibirá un correo con la url para descargarlo.',
    error = 'Error durante la descarga:'
}